import { Box } from "@mui/material";
import VolumePreview from "../components/articles-preview";
import FAQ from "../components/faq";
import Footer from "../components/footer";
import JoinPeerReview from "../components/join-peer-review";
import BecomeAuthor from "../components/become-author";
import Contribute from "../components/contribute";
import HomeNavbar from "../components/home-nav-bar";
import Navbar from "../components/home-nav-bar";
import ArticlesPreview from "../components/articles-preview";
import VolumesPreview from "../components/volumes-preview";
import JournalHeader from "../components/journal-header";
import SubmitManuscriptCard from "../components/submit-manuscript";
import AboutUs from "../components/about-us";

function Home() {
    return (
        <Box>
            <JournalHeader/>

            <HomeNavbar/>
            <SubmitManuscriptCard/>
            
            <VolumesPreview/>
            <ArticlesPreview/>
            <AboutUs/>
            <Contribute/>
            <FAQ/>
            <Footer/>
        </Box>
    );
}

export default Home;